import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  size?: 'normal' | 'large';
}

export default function ArticleCard({ article, size = 'normal' }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className={`group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
        size === 'large' ? 'flex flex-col md:flex-row' : ''
      }`}
    >
      <div className={`relative overflow-hidden ${size === 'large' ? 'md:w-2/5 md:min-h-48' : 'aspect-[16/9]'}`}>
        <img
          src={article.coverImage}
          alt={article.title}
          title={`${article.title} - 国产视频大全`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className={`p-4 md:p-5 ${size === 'large' ? 'md:w-3/5' : ''}`}>
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium">
            {article.tags[0]}
          </span>
          <span className="text-xs text-foreground-500">{article.readTime} 分钟阅读</span>
        </div>
        <h3 className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2 ${
          size === 'large' ? 'text-lg md:text-xl' : 'text-sm md:text-base'
        }`}>
          {article.title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 mb-3">{article.excerpt}</p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{article.author}</span>
          <span>{article.publishDate}</span>
        </div>
      </div>
    </Link>
  );
}